import httpClient from "../http/http-client";
import { IConversionSource, IConversionSourceWithConversions, IPostConversionSource } from './conversion-source.model';

export default class ConversionSourceService {
  http;
  constructor() {
    this.http = httpClient
  }

  async getAll(active?: boolean, conversionType?: 'conversion' | 'spendBasedConversion' | 'squareFootConversion', queryString?: string): Promise<IConversionSource[]> {
    // Joined properly so the type filter survives without an active filter: the old
    // string concatenation produced "conversion-source&conversionType=..." (no "?"),
    // which the API read as no filter at all and returned every source of every type.
    const params = [
      active !== undefined ? `active=${active}` : '',
      conversionType ? `conversionType=${conversionType}` : '',
      queryString || ''
    ].filter(Boolean).join('&')
    return this.http.get(`conversion-source${params ? `?${params}` : ''}`)
      .then(response => {
        return response.data.rows
      })
      .catch(err => {
        throw err
      });
  }

  async getAllWithPagination(page: number, perPage: number = 10, orderBy?: string, order?: 'asc' | 'desc', queryString?: string): Promise<{ count: number, rows: IConversionSource[] }> {
    return this.http.get(`conversion-source?page=${page}&perPage=${perPage}${order && orderBy ? `&orderBy=${orderBy}&order=${order}` : ''}${queryString ? `&${queryString}` : ''}`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err)
        throw err;
      });
  }

  async getOne(conversionSourceId: string, queryString?: string): Promise<IConversionSourceWithConversions> {
    return this.http.get(`conversion-source/${conversionSourceId}${queryString ? `${queryString}` : ''}`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        throw err
      });
  }

  async getConversionSourceForCategory(categoryId: string, conversionType: 'conversion' | 'spendBasedConversion' | 'squareFootConversion', scope: string, active?: boolean): Promise<IConversionSource[]> {
    return this.http.get(`conversion-source/category/${categoryId}?conversionType=${conversionType}&scope=${scope}${active ? `&active=${active}` : ''}`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        throw err
      });
  }

  async create(values: IPostConversionSource): Promise<IConversionSource> {
    return this.http.post('conversion-source', values)
      .then(response => {
        return response.data
      })
      .catch(err => {
        throw err
      });
  }

  async update(conversionSourceId: string, values: IPostConversionSource): Promise<IConversionSource> {
    return this.http.patch(`conversion-source/${conversionSourceId}`, values)
      .then(response => {
        return response.data
      })
      .catch(err => {
        throw err
      });
  }

  async activate(conversionSourceId: string): Promise<void> {
    return this.http.patch(`conversion-source/${conversionSourceId}/activate`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        throw err
      });
  }
  
  async deactivate(conversionSourceId: string): Promise<void> {
    return this.http.patch(`conversion-source/${conversionSourceId}/deactivate`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        throw err
      });
  }
}